import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_lpo = async (lpo) => {
  try {
    const data = {
      supplier: lpo?.supplier,
      project: lpo?.project,
      number: lpo?.number,
      invoice: lpo?.invoice,
      date: lpo?.date,
      due_date: lpo?.due_date,
      status: lpo?.status,
      details: lpo?.details,
      subtotal: lpo?.subtotal,
      taxamount: lpo?.taxamount,
      discount: lpo?.discount,
      delivery: lpo?.delivery,
      delivery_status: lpo?.delivery_status,
      delivery_date: lpo?.delivery_date,
      payment_status: lpo?.payment_status,
      payment_types: JSON?.stringify(lpo?.payment_types),
      payments: JSON?.stringify(lpo?.payments),
      total: lpo?.total,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-lpo`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_lpo = async (lpo) => {
  try {
    const data = {
      id: lpo?.id,
      supplier: lpo?.supplier,
      project: lpo?.project,
      number: lpo?.number,
      invoice: lpo?.invoice,
      date: lpo?.date,
      due_date: lpo?.due_date,
      status: lpo?.status,
      details: lpo?.details,
      subtotal: lpo?.subtotal,
      taxamount: lpo?.taxamount,
      discount: lpo?.discount,
      delivery: lpo?.delivery,
      delivery_status: lpo?.delivery_status,
      delivery_date: lpo?.delivery_date,
      payment_status: lpo?.payment_status,
      payment_types: JSON?.stringify(lpo?.payment_types),
      payments: JSON?.stringify(lpo?.payments),
      total: lpo?.total,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-lpo`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_lpo = async (lpo) => {
  try {
    const data = {
      id: lpo?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-lpo`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_lpo = async (lpo) => {
  try {
    const data = {
      id: lpo?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-lpo`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_lpo_order_inventories = async (lpo) => {
  try {
    const data = {
      id: lpo?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-lpo-inventories`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_lpos = async (lpo) => {
  try {
    const data = {
      search: lpo?.search,
      sort: lpo?.sort,
      supplier: lpo?.supplier,
      contractor: lpo?.contractor,
      date: lpo?.date,
      due_date: lpo?.due_date,
      page: lpo?.page,
      status: lpo?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-lpos`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_lpos_details = async (lpo) => {
  try {
    const data = {
      search: lpo?.search,
      sort: lpo?.sort,
      supplier: lpo?.supplier,
      contractor: lpo?.contractor,
      date: lpo?.date,
      due_date: lpo?.due_date,
      status: lpo?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-lpos-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_lpo_log = async (lpo) => {
  try {
    const data = {
      search: lpo?.search,
      sort: lpo?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-lpo-log`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_lpo_logs = async (lpo) => {
  try {
    const data = {
      search: lpo?.search,
      sort: lpo?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-lpo-logs`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_lpo,
  update_lpo,
  delete_lpo,
  get_lpo,
  get_lpo_order_inventories,
  get_all_lpos,
  get_all_lpos_details,
  get_lpo_log,
  get_all_lpo_logs,
};
